import React, { createContext, useContext, useState } from 'react';

const translations = {
  sk: {
    nav: {
      home: 'Domov',
      accommodation: 'Ubytovanie',
      resort: 'Rezort',
      gallery: 'Galéria',
      contact: 'Kontakt',
    },
    home: {
      tagline: 'BARVINOK',
      title: 'Elegancia v',
      titleHighlight: 'každom',
      titleEnd: 'detaile',
      subtitle: 'Chata, kde SKI-IN SKI-OUT nie je iba frázou.',
      reserve: 'Rezervovať',
      learnMore: 'Zistiť viac',
      about: 'O nás',
      aboutTitle: 'Chata Barvinok',
      aboutSubtitle: 'Váš domov pre každú príležitosť',
      // Charakteristika chaty
      aboutText1: 'Chata sa nachádza v krásnom a malebnom prostredí neďaleko Pieninského národného parku, v obci Litmanová, priamo oproti lyžiarskemu vleku. Je citlivo zasadená do okolitej chatovej zástavby, pričom svojím štýlom a atmosférou prirodzene vyniká. Okolie ponúka pokoj prírody, nádherné výhľady a množstvo možností na aktívny oddych počas celého roka.',
      aboutText2: 'V zimných mesiacoch ocenia návštevníci blízkosť lyžiarskeho strediska, zatiaľ čo v letnom období je lokalita ideálnym východiskovým bodom pre turistiku, cykloturistiku či objavovanie krás Pienin. Chata poskytuje príjemné a útulné prostredie vhodné pre rodiny, skupiny priateľov aj všetkých, ktorí hľadajú oddych v tichom horskom prostredí s priamym kontaktom s prírodou.',
      satisfaction: 'Spokojnosť',
      available: 'Dostupnosť',
      years: 'Rokov',
      qualityHigh: 'Na úrovni',
      environmentPleasant: 'TOP',
      yearsCount: '20+',
      gallery: 'Galéria',
      galleryTitle: 'Naše priestory',
      gallerySubtitle: 'Pozrite sa na atmosféru, ktorú vytvárame pre našich hostí',
      interior: 'Interiér',
      interiorDesc: 'Moderný a útulný priestor',
      atmosphere: 'Atmosféra',
      atmosphereDesc: 'Nezabudnuteľné chvíle',
      exterior: 'Exteriér',
      exteriorDesc: 'Pohľad na chatu a jej okolie',
      contact: 'Kontakt',
      contactTitle: 'Spojte sa s nami',
      contactSubtitle: 'Radi vám odpovieme na všetky vaše otázky',
      phone: 'Telefón',
      email: 'Email',
      address: 'Adresa',
      reviews: 'Čo hovoria o nás naši zákazníci',
      footer: {
        description: 'Váš domov pre nezabudnuteľné chvíle a skvelé zážitky.',
        navigation: 'Navigácia',
        contact: 'Kontakt',
        rights: 'Všetky práva vyhradené.',
      },
    },
    contact: {
      mapTitle: 'Naša poloha',
      mapSubtitle: 'Nájdite nás jednoducho pomocou mapy',
      openInMaps: 'Otvoriť v Google Maps',
      footer: {
        description: 'Váš domov pre nezabudnuteľné chvíle a skvelé zážitky.',
        navigation: 'Navigácia',
        contact: 'Kontakt',
        rights: 'Všetky práva vyhradené.',
      },
    },
    accommodation: {
      title: 'Ubytovanie',
      subtitle: 'Komfort? U Nás áno!',
      rooms: 'Izby',
      roomsDesc: 'Naša chata ponúka pohodlné a útulné izby pre všetkých hostí.',
      roomsDetails: '4 spálne • 8 lôžok + 4 prístelky • 3 kúpeľne, 3 toalety',
      parking: 'Parkovanie',
      parkingDesc: 'Bezplatné parkovanie je k dispozícii pre všetkých hostí.',
      parkingDetails: '2 parkovacie miesta',
      amenities: 'Vybavenie',
      amenitiesDesc: 'Moderné vybavenie a všetko, čo potrebujete pre pohodlný pobyt.',
      wifi: 'Wi-Fi',
      kitchen: 'Kuchyňa',
      tv: 'TV',
      fireplace: 'Krb',
      capacity: 'Podrobnosti',
      capacityDesc: 'Chata je vhodná pre rodiny aj skupiny.',
      capacityDetails: 'Max. 12 osôb',
      comfort: 'Komfort',
      comfortDesc: 'Každá izba je navrhnutá s dôrazom na pohodlie a relaxáciu.',
      safety: 'Bezpečnosť',
      safetyDesc: 'Váš pokoj a bezpečnosť sú našou prioritou počas celého pobytu.',
      experience: 'Zážitok',
      experienceDesc: 'Vytvárame nezabudnuteľné zážitky pre každého hosta.',
      bookingTitle: 'Rezervácia',
      bookingDesc: 'Kontaktujte nás pre rezerváciu a získajte najlepšie ceny a dostupnosť.',
      checkIn: 'Check-in: 15:00',
      checkOut: 'Check-out: 11:00',
      minStay: 'Min. pobyt: 2 noci',
      more: 'Viac',
      area: 'Rozloha:',
      maxPersons: 'Max',
      personsCount: 'Počet osôb:',
      room1: '2× Dvojlôžková izba s prístelkou',
      room2: '1× Štvorlôžková izba',
      room3: '1× Detská obývačka s gaučom',
      room4: 'Obývacia Izba',
      kitchen: 'Kuchyňa',
      dining: 'Jedáleň',
      bathroom: 'Kúpeľňa',
      bathroom2: 'Kúpeľňa 2',
      bathroom3: 'Toaleta',
      wardrobe: 'Vchod',
      skiRoom: 'Lyžiareň',
      terrace: 'Terasa',
      calendar: 'Kalendár',
      beds: 'Lôžka',
      bedSingular: 'lôžko',
      bedPlural: 'lôžka',
      toilet: 'Toaleta',
      equipment: 'Vybavenie',
      location: 'Umiestnenie',
      floor: 'Podlažie',
      view: 'Výhľad',
      additionalInfo: 'Doplňujúce informácie',
      doubleBed: 'Manželská posteľ',
      extraBed: 'Prístelka',
      foldingChair: 'Rozkladacie kreslo',
      bunkBed: 'Poschodová posteľ',
      sofaBed: 'Prístelka (gauč)',
      spaciousRoom: 'Priestraná izba',
      wc: 'WC',
      shower: 'Sprchovací kút',
      sink: 'Umývadlo',
      dryingRack: 'Stojan na sušenie bielizne',
      towels: 'Uteráky',
      countrysideView: 'Výhľad na okolitú krajinu',
      slopeView: 'Výhľad na zjazdovku',
      sauna: 'Sauna',
      bedrooms: 'Spálne',
      bedsCount: '8 lôžok + 4 prístelky',
      bathroomsCount: '3 kúpeľne, 3 toalety',
      partiallyFenced: 'Čiastočne oplotené',
      petsNotAllowed: 'Zvieratá nepovolené',
      familyFriendly: 'Pre rodiny s deťmi',
      restaurantNearby: 'Reštaurácia do 50 m',
      twoSaunas: '2 krby',
      pricing: 'Cenník',
      pricingNote: 'Pre viac informácií nás neváhajte kontaktovať. Radi vám všetko vysvetlíme.',
      winterSeason: 'Zimná sezóna',
      winterSeasonDates: '16. 12. – 18. 3.',
      winterSeasonPrice: '300 €',
      winterSeasonDetails: 'objekt / noc',
      winterSeasonMin: 'min. 2 osoby, min. 3 noci',
      offSeason: 'Mimosezóna',
      offSeasonDates: '19. 3. – 17. 6.',
      offSeasonPrice: '200 €',
      offSeasonDetails: 'objekt / noc',
      offSeasonMin: 'min. 2 osoby, min. 2 noci',
      easterStay: 'Veľkonočný pobyt',
      easterStayDates: '3. 4. – 6. 4.',
      easterStayPrice: '250 €',
      easterStayDetails: 'objekt / noc',
      easterStayMin: 'min. 2 osoby, min. 3 noci',
      summerSeason: 'Letná sezóna',
      summerSeasonDates: '18. 6. – 10. 9.',
      summerSeasonPrice: '250 €',
      summerSeasonDetails: 'objekt / noc',
      summerSeasonMin: 'min. 2 osoby, min. 3 noci',
      winterOffSeason: 'Zimná mimosezóna',
      winterOffSeasonDates: '11. 9. – 15. 12.',
      winterOffSeasonPrice: '200 €',
      winterOffSeasonDetails: 'objekt / noc',
      winterOffSeasonMin: 'min. 2 osoby, min. 2 noci',
      christmasStay: 'Vianočný pobyt',
      christmasStayDates: '22. 12. – 28. 12.',
      christmasStayPrice: '330 €',
      christmasStayDetails: 'objekt / noc',
      christmasStayMin: 'min. 2 osoby, min. 3 noci',
      newYear: 'Silvester',
      newYearDates: '29. 12. – 4. 1.',
      newYearPrice: '500 €',
      newYearDetails: 'objekt / noc',
      newYearMin: 'min. 2 osoby, min. 4 noci',
      period: 'Obdobie',
      price: 'Cena',
      conditions: 'Podmienky',
    },
    resort: {
      title: 'Rezort Litmanová',
      subtitle: 'Nachádzame sa v centre rezortu Litmanová',
      description: 'Chata Barvinok sa nachádza v srdci krásneho rezortu Litmanová, obklopená nádhernou prírodou a ponúkajúca jedinečné zážitky pre všetkých návštevníkov.',
      description2: 'Rezort Litmanová je ideálnym miestom pre relaxáciu, aktivity v prírode a rodinnú zábavu. Nachádza sa v krásnom prostredí s výhľadom na okolité hory a ponúka širokú škálu možností pre všetkých návštevníkov.',
      importantNote: 'Dôležitá informácia',
      importantNoteText: 'Rezort Litmanová a Chata Barvinok sú dve nezávislé veci. Chata Barvinok je samostatné ubytovacie zariadenie, ktoré sa nachádza v oblasti rezortu, ale funguje nezávisle od rezortu.',
      location: 'Poloha',
      locationDesc: 'Výhodná poloha v centre rezortu s ľahkým prístupom k všetkým atrakciám.',
      locationItem1: 'Centrálna poloha v rezorte',
      locationItem2: 'Ľahký prístup k atrakciám',
      nature: 'Príroda',
      natureDesc: 'Obklopení nádhernou prírodou a čistým vzduchom.',
      natureItem1: 'Horské prostredie',
      natureItem2: 'Čistý vzduch a pokoj',
      activities: 'Aktivity',
      activitiesDesc: 'Široká ponuka aktivít a zábavy pre celú rodinu.',
      activitiesItem1: 'Lyžovanie a zimné športy',
      activitiesItem2: 'Turistika a cyklistika',
      activitiesItem3: 'Rodinné aktivity',
      seasons: 'Ročné obdobia',
      seasonsDesc: 'Rezort je atraktívny počas celého roka.',
      season1: 'Zima - lyžovanie a zimné športy',
      season2: 'Leto - turistika a príroda',
      season3: 'Jeseň - farebné listy a relaxácia',
      facilities: 'Zariadenia rezortu',
      facilitiesDesc: 'V oblasti rezortu nájdete rôzne zariadenia a služby.',
      facility1: 'Lyžiarske vleky',
      facility2: 'Bufety',
      facility3: 'Požičovne lyží',
      facility4: 'Zábavné aktivity',
      experienceTitle: 'Zážitky v rezorte',
      experienceDesc: 'Rezort Litmanová ponúka nezabudnuteľné zážitky počas celého roka. Či už prichádzate na lyžovanie v zime, turistiku v lete alebo len relaxáciu v jeseni, nájdete tu niečo pre každého.',
      experienceDesc2: 'Naša chata sa nachádza v ideálnej vzdialenosti od všetkých atrakcií rezortu, čo vám umožňuje plne využiť všetky možnosti, ktoré rezort ponúka, a zároveň si užívať súkromie a pohodlie vášho ubytovania.',
      satisfaction: 'Pocit',
      available: 'Prostredie',
      years: 'Rokov',
      qualityHigh: 'Príjemný',
      environmentPleasant: 'TOP',
      yearsCount: '20+',
    },
  },
  pl: {
    nav: {
      home: 'Strona główna',
      accommodation: 'Zakwaterowanie',
      resort: 'Ośrodek',
      gallery: 'Galeria',
      contact: 'Kontakt',
    },
    home: {
      tagline: 'BARVINOK',
      title: 'Elegancja w',
      titleHighlight: 'każdym',
      titleEnd: 'szczególe',
      subtitle: 'Chata, gdzie SKI-IN SKI-OUT nie jest tylko frazą.',
      reserve: 'Rezerwuj',
      learnMore: 'Dowiedz się więcej',
      about: 'O nas',
      aboutTitle: 'Chata Barvinok',
      aboutSubtitle: 'Twój dom na każdą okazję',
      aboutText1: 'Chata znajduje się w pięknym i malowniczym otoczeniu niedaleko Pienińskiego Parku Narodowego, w miejscowości Litmanová, bezpośrednio naprzeciwko wyciągu narciarskiego. Jest harmonijnie wkomponowana w okoliczną zabudowę letniskową, a swoim stylem i atmosferą naturalnie się wyróżnia. Okolica oferuje spokój natury, piękne widoki i wiele możliwości aktywnego wypoczynku przez cały rok.',
      aboutText2: 'Zimą goście docenią bliskość ośrodka narciarskiego, natomiast latem lokalizacja jest idealnym punktem wyjścia do turystyki pieszej, rowerowej oraz odkrywania uroków Pienin. Chata zapewnia przyjemne i przytulne środowisko odpowiednie dla rodzin, grup przyjaciół oraz wszystkich, którzy szukają odpoczynku w cichym górskim otoczeniu w bezpośrednim kontakcie z naturą.',
      satisfaction: 'Satysfakcja',
      available: 'Dostępność',
      years: 'Lat',
      qualityHigh: 'Wysoka',
      environmentPleasant: 'Przyjemne',
      yearsCount: '20+',
      gallery: 'Galeria',
      galleryTitle: 'Nasze przestrzenie',
      gallerySubtitle: 'Zobacz atmosferę, którą tworzymy dla naszych gości',
      interior: 'Wnętrze',
      interiorDesc: 'Nowoczesna i przytulna przestrzeń',
      atmosphere: 'Atmosfera',
      atmosphereDesc: 'Niezapomniane chwile',
      exterior: 'Eksterier',
      exteriorDesc: 'Widok na chatę i jej otoczenie',
      contact: 'Kontakt',
      contactTitle: 'Skontaktuj się z nami',
      contactSubtitle: 'Chętnie odpowiemy na wszystkie Twoje pytania',
      phone: 'Telefon',
      email: 'Email',
      address: 'Adres',
      reviews: 'Co mówią o nas nasi klienci',
      footer: {
        description: 'Twój dom na niezapomniane chwile i wspaniałe wrażenia.',
        navigation: 'Nawigacja',
        contact: 'Kontakt',
        rights: 'Wszelkie prawa zastrzeżone.',
      },
    },
    contact: {
      mapTitle: 'Nasza lokalizacja',
      mapSubtitle: 'Znajdź nas łatwo za pomocą mapy',
      openInMaps: 'Otwórz w Google Maps',
      footer: {
        description: 'Twój dom na niezapomniane chwile i wspaniałe wrażenia.',
        navigation: 'Nawigacja',
        contact: 'Kontakt',
        rights: 'Wszelkie prawa zastrzeżone.',
      },
    },
    accommodation: {
      title: 'Zakwaterowanie',
      subtitle: 'Komfort? U Nas tak!',
      rooms: 'Pokoje',
      roomsDesc: 'Nasza chata oferuje wygodne i przytulne pokoje dla wszystkich gości.',
      roomsDetails: '4 sypialnie • 8 łóżek + 4 dodatkowe łóżka • 3 łazienki, 3 toalety',
      parking: 'Parking',
      parkingDesc: 'Darmowy parking jest dostępny dla wszystkich gości.',
      parkingDetails: '2 miejsca parkingowe',
      amenities: 'Udogodnienia',
      amenitiesDesc: 'Nowoczesne wyposażenie i wszystko, czego potrzebujesz do komfortowego pobytu.',
      wifi: 'Wi-Fi',
      kitchen: 'Kuchnia',
      tv: 'TV',
      fireplace: 'Kominek',
      capacity: 'Szczegóły',
      capacityDesc: 'Chata jest odpowiednia dla rodzin i grup.',
      capacityDetails: 'Max. 12 osób',
      comfort: 'Komfort',
      comfortDesc: 'Każdy pokój jest zaprojektowany z naciskiem na komfort i relaks.',
      safety: 'Bezpieczeństwo',
      safetyDesc: 'Twój spokój i bezpieczeństwo są naszym priorytetem przez cały pobyt.',
      experience: 'Doświadczenie',
      experienceDesc: 'Tworzymy niezapomniane doświadczenia dla każdego gościa.',
      bookingTitle: 'Rezerwacja',
      bookingDesc: 'Skontaktuj się z nami, aby zarezerwować i uzyskać najlepsze ceny i dostępność.',
      checkIn: 'Zameldowanie: 15:00',
      checkOut: 'Wymeldowanie: 11:00',
      minStay: 'Min. pobyt: 2 noce',
      more: 'Więcej',
      area: 'Powierzchnia:',
      maxPersons: 'Max',
      personsCount: 'Liczba osób:',
      room1: '2× Pokój dwuosobowy z dodatkowym łóżkiem',
      room2: '1× Pokój czteroosobowy',
      room3: '1× Pokój dzienny dla dzieci z kanapą',
      room4: 'Salon 2',
      kitchen: 'Kuchnia',
      dining: 'Jadalnia',
      bathroom: 'Łazienka',
      bathroom2: 'Łazienka 2',
      bathroom3: 'Toaleta',
      wardrobe: 'Wejście',
      skiRoom: 'Schronisko narciarskie',
      terrace: 'Taras',
      calendar: 'Kalendarz',
      beds: 'Łóżka',
      bedSingular: 'łóżko',
      bedPlural: 'łóżka',
      toilet: 'Toaleta',
      equipment: 'Wyposażenie',
      location: 'Lokalizacja',
      floor: 'Piętro',
      view: 'Widok',
      additionalInfo: 'Dodatkowe informacje',
      doubleBed: 'Łóżko małżeńskie',
      extraBed: 'Dodatkowe łóżko',
      foldingChair: 'Rozkładane krzesło',
      bunkBed: 'Łóżko piętrowe',
      sofaBed: 'Dodatkowe łóżko (kanapa)',
      spaciousRoom: 'Przestronny pokój',
      wc: 'WC',
      shower: 'Kabina prysznicowa',
      sink: 'Umywalka',
      dryingRack: 'Stojak do suszenia bielizny',
      towels: 'Ręczniki',
      countrysideView: 'Widok na okolicę',
      slopeView: 'Widok na stok',
      sauna: 'Sauna',
      bedrooms: 'Sypialnie',
      bedsCount: '8 łóżek + 4 dodatkowe łóżka',
      bathroomsCount: '3 łazienki, 3 toalety',
      partiallyFenced: 'Częściowo ogrodzone',
      petsNotAllowed: 'Zwierzęta niedozwolone',
      familyFriendly: 'Dla rodzin z dziećmi',
      restaurantNearby: 'Restauracja do 50 m',
      twoSaunas: '2 kominki',
      pricing: 'Cennik',
      pricingNote: 'Po więcej informacji prosimy o kontakt. Z przyjemnością wszystko wyjaśnimy.',
      winterSeason: 'Sezon zimowy',
      winterSeasonDates: '16. 12. – 18. 3.',
      winterSeasonPrice: '300 €',
      winterSeasonDetails: 'obiekt / noc',
      winterSeasonMin: 'min. 2 osoby, min. 3 noce',
      offSeason: 'Poza sezonem',
      offSeasonDates: '19. 3. – 17. 6.',
      offSeasonPrice: '200 €',
      offSeasonDetails: 'obiekt / noc',
      offSeasonMin: 'min. 2 osoby, min. 2 noce',
      easterStay: 'Pobyt wielkanocny',
      easterStayDates: '3. 4. – 6. 4.',
      easterStayPrice: '250 €',
      easterStayDetails: 'obiekt / noc',
      easterStayMin: 'min. 2 osoby, min. 3 noce',
      summerSeason: 'Sezon letni',
      summerSeasonDates: '18. 6. – 10. 9.',
      summerSeasonPrice: '250 €',
      summerSeasonDetails: 'obiekt / noc',
      summerSeasonMin: 'min. 2 osoby, min. 3 noce',
      winterOffSeason: 'Zimowy poza sezonem',
      winterOffSeasonDates: '11. 9. – 15. 12.',
      winterOffSeasonPrice: '200 €',
      winterOffSeasonDetails: 'obiekt / noc',
      winterOffSeasonMin: 'min. 2 osoby, min. 2 noce',
      christmasStay: 'Pobyt świąteczny',
      christmasStayDates: '22. 12. – 28. 12.',
      christmasStayPrice: '330 €',
      christmasStayDetails: 'obiekt / noc',
      christmasStayMin: 'min. 2 osoby, min. 3 noce',
      newYear: 'Sylwester',
      newYearDates: '29. 12. – 4. 1.',
      newYearPrice: '500 €',
      newYearDetails: 'obiekt / noc',
      newYearMin: 'min. 2 osoby, min. 4 noce',
      period: 'Okres',
      price: 'Cena',
      conditions: 'Warunki',
    },
    resort: {
      title: 'Ośrodek Litmanová',
      subtitle: 'Znajdujemy się w centrum ośrodka Litmanová',
      description: 'Chata Barvinok znajduje się w sercu pięknego ośrodka Litmanová, otoczony wspaniałą przyrodą i oferujący wyjątkowe wrażenia dla wszystkich odwiedzających.',
      description2: 'Ośrodek Litmanová jest idealnym miejscem na relaks, aktywności na świeżym powietrzu i rozrywkę dla całej rodziny. Znajduje się w pięknym otoczeniu z widokiem na okoliczne góry i oferuje szeroki wachlarz możliwości dla wszystkich odwiedzających.',
      importantNote: 'Ważna informacja',
      importantNoteText: 'Ośrodek Litmanová i Chata Barvinok to dwie niezależne rzeczy. Chata Barvinok jest niezależnym obiektem noclegowym, który znajduje się w obszarze ośrodka, ale działa niezależnie od ośrodka.',
      location: 'Lokalizacja',
      locationDesc: 'Dogodna lokalizacja w centrum ośrodka z łatwym dostępem do wszystkich atrakcji.',
      locationItem1: 'Centralna lokalizacja w ośrodku',
      locationItem2: 'Łatwy dostęp do atrakcji',
      nature: 'Przyroda',
      natureDesc: 'Otoczeni piękną przyrodą i czystym powietrzem.',
      natureItem1: 'Górskie otoczenie',
      natureItem2: 'Czyste powietrze i spokój',
      activities: 'Aktywności',
      activitiesDesc: 'Szeroka oferta aktywności i rozrywki dla całej rodziny.',
      activitiesItem1: 'Narciarstwo i sporty zimowe',
      activitiesItem2: 'Turystyka i kolarstwo',
      activitiesItem3: 'Aktywności rodzinne',
      seasons: 'Pory roku',
      seasonsDesc: 'Ośrodek jest atrakcyjny przez cały rok.',
      season1: 'Zima - narciarstwo i sporty zimowe',
      season2: 'Lato - turystyka i przyroda',
      season3: 'Jesień - kolorowe liście i relaks',
      facilities: 'Obiekty ośrodka',
      facilitiesDesc: 'W obszarze ośrodka znajdziesz różne obiekty i usługi.',
      facility1: 'Wyciągi narciarskie',
      facility2: 'Bufety',
      facility3: 'Wypożyczalnie nart',
      facility4: 'Rozrywka',
      experienceTitle: 'Doświadczenia w ośrodku',
      experienceDesc: 'Ośrodek Litmanová oferuje niezapomniane doświadczenia przez cały rok. Czy przyjeżdżasz na narty zimą, wędrówki latem czy tylko relaks jesienią, znajdziesz tu coś dla każdego.',
      experienceDesc2: 'Nasza chata znajduje się w idealnej odległości od wszystkich atrakcji ośrodka, co pozwala w pełni wykorzystać wszystkie możliwości, które ośrodek oferuje, a jednocześnie cieszyć się prywatnością i komfortem swojego zakwaterowania.',
      satisfaction: 'Jakość',
      available: 'Otoczenie',
      years: 'Lat',
      qualityHigh: 'Wysoka',
      environmentPleasant: 'Przyjemne',
      yearsCount: '20+',
    },
  },
  en: {
    nav: {
      home: 'Home',
      accommodation: 'Accommodation',
      resort: 'Resort',
      gallery: 'Gallery',
      contact: 'Contact',
    },
    home: {
      tagline: 'BARVINOK',
      title: 'Elegance in',
      titleHighlight: 'every',
      titleEnd: 'detail',
      subtitle: 'Cottage where SKI-IN SKI-OUT is not just a phrase.',
      reserve: 'Reserve',
      learnMore: 'Learn More',
      about: 'About Us',
      aboutTitle: 'Cottage Barvinok',
      aboutSubtitle: 'Your home for every occasion',
      aboutText1: 'The cottage is located in a beautiful and picturesque setting near the Pieniny National Park, in the village of Litmanová, directly opposite the ski lift. It is sensitively integrated into the surrounding cottage development, while its style and atmosphere make it naturally stand out. The surroundings offer the peace of nature, wonderful views and many opportunities for active relaxation throughout the year.',
      aboutText2: 'In the winter months, visitors will appreciate the proximity of the ski resort, while in the summer the location is an ideal starting point for hiking, cycling and discovering the beauty of the Pieniny mountains. The cottage provides a pleasant and cozy environment suitable for families, groups of friends and all those who are looking for rest in a quiet mountain setting in direct contact with nature.',
      satisfaction: 'Satisfaction',
      available: 'Availability',
      years: 'Years',
      qualityHigh: 'High',
      environmentPleasant: 'Pleasant',
      yearsCount: '20+',
      gallery: 'Gallery',
      galleryTitle: 'Our Spaces',
      gallerySubtitle: 'See the atmosphere we create for our guests',
      interior: 'Interior',
      interiorDesc: 'Modern and cozy space',
      atmosphere: 'Atmosphere',
      atmosphereDesc: 'Unforgettable moments',
      exterior: 'Exterior',
      exteriorDesc: 'View of the cottage and its surroundings',
      contact: 'Contact',
      contactTitle: 'Get in Touch',
      contactSubtitle: 'We are happy to answer all your questions',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      reviews: 'What our customers say about us',
      footer: {
        description: 'Your home for unforgettable moments and great experiences.',
        navigation: 'Navigation',
        contact: 'Contact',
        rights: 'All rights reserved.',
      },
    },
    contact: {
      mapTitle: 'Our Location',
      mapSubtitle: 'Find us easily using the map',
      openInMaps: 'Open in Google Maps',
      footer: {
        description: 'Your home for unforgettable moments and great experiences.',
        navigation: 'Navigation',
        contact: 'Contact',
        rights: 'All rights reserved.',
      },
    },
    accommodation: {
      title: 'Accommodation',
      subtitle: 'Comfort? At Our Place Yes!',
      rooms: 'Rooms',
      roomsDesc: 'Our cottage offers comfortable and cozy rooms for all guests.',
      roomsDetails: '4 bedrooms • 8 beds + 4 extra beds • 3 bathrooms, 3 toilets',
      parking: 'Parking',
      parkingDesc: 'Free parking is available for all guests.',
      parkingDetails: '2 parking spaces',
      amenities: 'Amenities',
      amenitiesDesc: 'Modern amenities and everything you need for a comfortable stay.',
      wifi: 'Wi-Fi',
      kitchen: 'Kitchen',
      tv: 'TV',
      fireplace: 'Fireplace',
      capacity: 'Details',
      capacityDesc: 'The cottage is suitable for families and groups.',
      capacityDetails: 'Max. 12 people',
      comfort: 'Comfort',
      comfortDesc: 'Each room is designed with emphasis on comfort and relaxation.',
      safety: 'Safety',
      safetyDesc: 'Your peace and safety are our priority throughout your stay.',
      experience: 'Experience',
      experienceDesc: 'We create unforgettable experiences for every guest.',
      bookingTitle: 'Booking',
      bookingDesc: 'Contact us to book and get the best prices and availability.',
      checkIn: 'Check-in: 15:00',
      checkOut: 'Check-out: 11:00',
      minStay: 'Min. stay: 2 nights',
      more: 'More',
      area: 'Area:',
      maxPersons: 'Max. persons',
      personsCount: 'Number of persons:',
      room1: '2× Double Room with Extra Bed',
      room2: '1× Quad Room',
      room3: '1× Children\'s Living Room with Sofa Bed',
      room4: 'Living Room 2',
      kitchen: 'Kitchen',
      dining: 'Dining Room',
      bathroom: 'Bathroom',
      bathroom2: 'Bathroom 2',
      bathroom3: 'Toilet',
      wardrobe: 'Entrance',
      skiRoom: 'Ski Room',
      terrace: 'Terrace',
      calendar: 'Calendar',
      beds: 'Beds',
      bedSingular: 'bed',
      bedPlural: 'beds',
      toilet: 'Toilet',
      equipment: 'Equipment',
      location: 'Location',
      floor: 'Floor',
      view: 'View',
      additionalInfo: 'Additional Information',
      doubleBed: 'Double Bed',
      extraBed: 'Extra Bed',
      foldingChair: 'Folding Chair',
      bunkBed: 'Bunk Bed',
      sofaBed: 'Extra Bed (Sofa)',
      spaciousRoom: 'Spacious Room',
      wc: 'WC',
      shower: 'Shower',
      sink: 'Sink',
      dryingRack: 'Drying Rack',
      towels: 'Towels',
      countrysideView: 'Countryside View',
      slopeView: 'Slope View',
      sauna: 'Sauna',
      bedrooms: 'Bedrooms',
      bedsCount: '8 beds + 4 extra beds',
      bathroomsCount: '3 bathrooms, 3 toilets',
      partiallyFenced: 'Partially fenced',
      petsNotAllowed: 'Pets not allowed',
      familyFriendly: 'Family friendly',
      restaurantNearby: 'Restaurant within 50 m',
      twoSaunas: '2 fireplaces',
      pricing: 'Pricing',
      pricingNote: 'For more information, please do not hesitate to contact us. We will be happy to explain everything.',
      winterSeason: 'Winter Season',
      winterSeasonDates: 'Dec 16 – Mar 18',
      winterSeasonPrice: '300 €',
      winterSeasonDetails: 'property / night',
      winterSeasonMin: 'min. 2 persons, min. 3 nights',
      offSeason: 'Off Season',
      offSeasonDates: 'Mar 19 – Jun 17',
      offSeasonPrice: '200 €',
      offSeasonDetails: 'property / night',
      offSeasonMin: 'min. 2 persons, min. 2 nights',
      easterStay: 'Easter Stay',
      easterStayDates: 'Apr 3 – Apr 6',
      easterStayPrice: '250 €',
      easterStayDetails: 'property / night',
      easterStayMin: 'min. 2 persons, min. 3 nights',
      summerSeason: 'Summer Season',
      summerSeasonDates: 'Jun 18 – Sep 10',
      summerSeasonPrice: '250 €',
      summerSeasonDetails: 'property / night',
      summerSeasonMin: 'min. 2 persons, min. 3 nights',
      winterOffSeason: 'Winter Off Season',
      winterOffSeasonDates: 'Sep 11 – Dec 15',
      winterOffSeasonPrice: '200 €',
      winterOffSeasonDetails: 'property / night',
      winterOffSeasonMin: 'min. 2 persons, min. 2 nights',
      christmasStay: 'Christmas Stay',
      christmasStayDates: 'Dec 22 – Dec 28',
      christmasStayPrice: '330 €',
      christmasStayDetails: 'property / night',
      christmasStayMin: 'min. 2 persons, min. 3 nights',
      newYear: 'New Year',
      newYearDates: 'Dec 29 – Jan 4',
      newYearPrice: '500 €',
      newYearDetails: 'property / night',
      newYearMin: 'min. 2 persons, min. 4 nights',
      period: 'Period',
      price: 'Price',
      conditions: 'Conditions',
    },
    resort: {
      title: 'Litmanová Resort',
      subtitle: 'We are located in the center of Litmanová resort',
      description: 'Cottage Barvinok is located in the heart of the beautiful Litmanová resort, surrounded by beautiful nature and offering unique experiences for all visitors.',
      description2: 'Litmanová Resort is an ideal place for relaxation, outdoor activities and family fun. It is located in a beautiful setting with views of the surrounding mountains and offers a wide range of options for all visitors.',
      importantNote: 'Important Information',
      importantNoteText: 'Litmanová Resort and Cottage Barvinok are two independent things. Cottage Barvinok is an independent accommodation facility located in the resort area, but operates independently from the resort.',
      location: 'Location',
      locationDesc: 'Convenient location in the center of the resort with easy access to all attractions.',
      locationItem1: 'Central location in the resort',
      locationItem2: 'Easy access to attractions',
      nature: 'Nature',
      natureDesc: 'Surrounded by beautiful nature and clean air.',
      natureItem1: 'Mountain environment',
      natureItem2: 'Clean air and peace',
      activities: 'Activities',
      activitiesDesc: 'Wide range of activities and entertainment for the whole family.',
      activitiesItem1: 'Skiing and winter sports',
      activitiesItem2: 'Hiking and cycling',
      activitiesItem3: 'Family activities',
      seasons: 'Seasons',
      seasonsDesc: 'The resort is attractive throughout the year.',
      season1: 'Winter - skiing and winter sports',
      season2: 'Summer - hiking and nature',
      season3: 'Autumn - colorful leaves and relaxation',
      facilities: 'Resort Facilities',
      facilitiesDesc: 'In the resort area you will find various facilities and services.',
      facility1: 'Ski lifts',
      facility2: 'Buffets',
      facility3: 'Ski rentals',
      facility4: 'Entertainment',
      experienceTitle: 'Resort Experiences',
      experienceDesc: 'Litmanová Resort offers unforgettable experiences throughout the year. Whether you come for skiing in winter, hiking in summer, or just relaxation in autumn, you will find something for everyone.',
      experienceDesc2: 'Our cottage is located at an ideal distance from all resort attractions, allowing you to fully utilize all the opportunities the resort offers, while enjoying the privacy and comfort of your accommodation.',
      satisfaction: 'Quality',
      available: 'Environment',
      years: 'Years',
      qualityHigh: 'High',
      environmentPleasant: 'Pleasant',
      yearsCount: '20+',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('sk');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

